import { ref } from 'vue';

export const useOnSubmit = (productId, checkoutlink) => {
    const isSubmitting = ref(false);
    const addedToCart = ref(false);
    const addedToCartMessage = ref(null);
    const onSubmit = (data) => {
        if (isSubmitting.value) {
            isSubmitting.value = false;
            return;
        }

        isSubmitting.value = true;

        const formData = new FormData();

        formData.append('action', 'add_to_cart');
        formData.append('product_id', productId);
        formData.append('quantity', 1);
        formData.append('metaData', JSON.stringify(data));
        formData.append('file', data.uploadedFile);

        fetch(jsData.ajaxUrl, {
            method: 'POST',
            body: formData,
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    window.location.href = checkoutlink;
                } else {
                    isSubmitting.value = false;
                    addedToCart.value = true;
                    addedToCartMessage.value = response.data.message;
                }
            });
    };

    return { onSubmit, isSubmitting, addedToCart, addedToCartMessage };
};
